import { SagaIterator } from 'redux-saga'
import { put, takeLatest, select, all } from 'redux-saga/effects'

import { getReadonlyContentFormSuccess } from '@tabeeb/shared/content/actions'
import { getContentId } from '@tabeeb/modules/shared/content/selectors'

import { Action } from 'redux-actions'
import { GetReadonlyContentFormsResponse } from '@tabeeb/contracts/main-api/swagger-main-api'
import {
  getAnswersStatusesCount,
  getFormControls,
  setReadonlySelectedTabs,
  setSelectedTabs,
  updateForm,
} from '../actions'

import { getContentForms } from '../selectors'

function* onGetFormControlsSuccess(action: ReturnType<typeof getFormControls.success>): SagaIterator {
  const { data } = action.response
  const contentId: ReturnType<typeof getContentId> = yield select(getContentId)

  if (data) {
    yield put(updateForm(data))

    const contentForms: ReturnType<typeof getContentForms> = yield select(getContentForms)

    const isExist = contentForms.some((e) => e.Id === action.payload.contentFormId)
    if (isExist) {
      yield put(getAnswersStatusesCount.request({ contentFormId: data.Id }))
    } else if (contentForms.length > 0) {
      yield put(getFormControls.request({ contentFormId: contentForms[0].Id }))
    }
    if (contentId) {
      if (data.Tabspanels && data.Tabspanels.length > 0) {
        yield put(setSelectedTabs(data.Tabspanels.map((panel) => panel.Tabs![0].Id)))
      } else {
        yield put(setSelectedTabs([]))
      }
    }
  }
}

function* setReadonlyForms(action: ReturnType<typeof getReadonlyContentFormSuccess>): SagaIterator {
  const {
    payload: { ContentForm },
  } = action as Action<GetReadonlyContentFormsResponse>
  if (ContentForm) {
    yield put(updateForm({ ...ContentForm, UserId: 0, HasAnswers: false }))

    const contentId: ReturnType<typeof getContentId> = yield select(getContentId)
    if (contentId) {
      const selectedTabs =
        ContentForm.Tabspanels && ContentForm.Tabspanels.length > 0
          ? ContentForm.Tabspanels.map((panel) => panel.Tabs![0].Id)
          : []
      yield put(setReadonlySelectedTabs(selectedTabs))
    }
  }
}

function* formControls() {
  yield all([
    takeLatest(getFormControls.success, onGetFormControlsSuccess),
    takeLatest(getReadonlyContentFormSuccess, setReadonlyForms),
  ])
}

export default formControls
